import type { CSS } from '../../stitches.config';
import { type SizingScale, isSpacingValue } from './sizes';

export type WidthTypes = SizingScale | string;
export type WidthProps = { width?: WidthTypes };

export function widthCSS(width?: WidthTypes): CSS {
  if (
    width === 'auto' ||
    width === 'fit-content' ||
    width === 'max-content' ||
    width === 'min-content'
  ) {
    return { width };
  }

  if (width === 'full' || width === '100%') {
    return { width: '100%' };
  }

  if (width === 'screen') {
    return { width: '100vw' };
  }

  if (typeof width === 'number' && isSpacingValue(width)) {
    return { width: `$${width}` };
  }

  if (typeof width === 'string') {
    return { width };
  }

  return {};
}
